module.exports = __webpack_public_path__ + "img/week.91c5c0d5.svg";